import { render, staticRenderFns } from "./how-old-is-your-child.vue?vue&type=template&id=5c6c194a&scoped=true&lang=pug&"
import script from "./how-old-is-your-child.vue?vue&type=script&lang=js&"
export * from "./how-old-is-your-child.vue?vue&type=script&lang=js&"
import style0 from "./how-old-is-your-child.vue?vue&type=style&index=0&id=5c6c194a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c194a",
  null
  
)

export default component.exports